import React from 'react';

export default function CategoryTabSkeleton({ count = 6 }: { count?: number }) {
    return (
        <>
            {Array.from({ length: count }).map((_, i) => (
                <div
                    key={i}
                    className={`animate-pulse bg-muted-color rounded-full h-10 shrink-0 ${i % 3 === 0 ? 'w-16' : i % 3 === 1 ? 'w-24' : 'w-20'}`}
                    aria-hidden
                />
            ))}
        </>
    );
}
